import React from "react";
const ToastMessage = ({
  statusImage,
  toastMessage,
  shortMessage,
  toastTextClass,
  claimFaucetTokens,
}) => {
  return (
    <div className="d-flex">
      {statusImage && (
        <div>
          <img src={statusImage} alt="" className="m-2 toastWarn" />
        </div>
      )}
      <div
        className={`${toastTextClass} ${
          claimFaucetTokens ? "d-flex align-items-center" : ""
        }`}
      >
        {shortMessage && <span>{shortMessage}</span>}
        {toastMessage && <p className="toastDesc">{toastMessage}</p>}
      </div>
    </div>
  );
};
export default ToastMessage;
